(ns common.widgets.menu
  {:deprecated true}
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            [mate.core :as mc]
            [uix.core :as uix :refer [defui $]]))

;; TODO: deprecate this and use material-ui-popup-state instead,
;;       decouple the button and the menu & menuItems.
;; https://wppchoreograph.slack.com/archives/C05F2HYBFEU/p1710250732677179?thread_ts=1710250588.354199&cid=C05F2HYBFEU
(defui menu
  [{:keys [items icon toggle-label toggle-props icon-props menu-props]}]
  (let [[anchor-el set-anchor-el] (uix/use-state nil)
        handle-click #(set-anchor-el (.. % -currentTarget))
        handle-close #(set-anchor-el nil)]
    ($ :<>
       (if toggle-label
         ($ Button
            (merge toggle-props
                   {:on-click handle-click
                    :data-testid "open-menu-button"})
            toggle-label)
         ($ IconButton
            (merge toggle-props
                   {:on-click handle-click
                    :data-testid "open-menu-button"})
            (if (string? icon)
              ($ Icon icon-props icon)
              icon)))
       ($ Menu (merge menu-props
                      {:anchor-el anchor-el
                       :open (some? anchor-el)
                       :on-close handle-close})
          (for [[idx item] (mc/seq-indexed items)
                :when (some? item)
                :let [{:keys [target icon label href on-click disabled?]} item]]
            ($ MenuItem {:key idx
                         :disabled disabled?
                         :href href
                         :target target
                         ;; If we have a href, make MUI use anchor element so
                         ;; the link works correctly i.e. with ctrl clicks and
                         ;; such.
                         :component (if (some? href) "a" "li")
                         :on-click (fn [e]
                                     (handle-close)
                                     (when on-click
                                       (on-click e)))
                         :data-testid label}
               (when (some? icon)
                 ($ ListItemIcon
                    ($ Icon icon)))
               ($ ListItemText label)))))))
